'use strict';

const storage = require('./storage-helper');

const {
  isClickFromDirectLink,
  updateDirectLink,
} = require('./tracking-helper');

const handleEvent = event => {
  if (event.id && event.type === 'click') {
    if (isClickFromDirectLink(event.widgets)) {
      updateDirectLink(event.widgets, event.id);
    } else {
      storage.setItem('eventId', event.id);
    }
  }
};

window.onload = function() {
  setTimeout(
    () => window.OptimizeSuite.bloodhound.on('event', handleEvent),
    100
  );
};
